import { dynamicSort } from '@/shared/utils/dynamicSort';
import angular from 'angular';
import { type } from 'os';

angular.module('cloudX').directive('cxTypeaheadDropdown', [
  '$parse',
  function($parse) {
    return {
      restrict: 'E',
      replace: true,
      template:
        '<div class="dropdown" uib-dropdown ng-show="options.length || allowInvalid" is-open="ddwOpen">' +
        ' <div class="input-group scrollable-typeahead {{iClass}}">' +
        '     <input type="text" ng-disabled="disabled" ng-model="selected" uib-typeahead="item as item.label for item in options | filter:{label:$viewValue||\'\'} | limitTo:limit " typeahead-min-length="0" typeahead-select-on-blur="selectOnBlur" typeahead-select-on-exact="selectOnExact" typeahead-on-select="onSelect($item)" ng-blur="onBlur()" ng-change="onChange()" ng-focus="ddwOpen=false" class="form-control" placeholder="{{placeholder}}" autocomplete="off" data-1p-ignore/>' +
        '     <div class="input-group-btn">' +
        '         <button class="btn btn-default btn-font-14" ng-click="clearSelected()" ng-disabled="disabled || !options.length" ng-show="showClearButton && selected">' +
        '             <span class="fa fa-times"></span>' +
        '         </button>' +
        '         <button class="btn btn-default dropdown-toggle btn-font-14" ng-attr-title="{{disabled || !options.length ? disabledtitle : \'\'}}" ng-disabled="disabled || !options.length" uib-dropdown-toggle>' +
        '             <span class="caret"></span>' +
        '         </button>' +
        '     </div>' +
        ' </div>' +
        ' <ul class="dropdown-menu dropdown-menu-right" role="menu" style="max-height:200px;overflow-y:auto">' +
        '     <li ng-repeat="op in options" ng-class="{\'selected\':op===selected}">' +
        '         <a href ng-click=onSelect(op)>{{op.label}}</a>' +
        '     </li>' +
        ' </ul>' +
        '</div>',
      require: 'ngModel',
      scope: {
        //mdl: '=ngModel',
        orgOptions: '=options',
        label: '@',
        allowInvalidInitialItem: '@?',
        labelFunc: '&?',
        autoSelect: '@?',
        disabled: '=?ngDisabled',
        placeholder: '@?',
        disabledtitle: '@?',
        showClearButton: '@?',
        iClass: '@?',
        noSort: '@?',
      },
      link: function(scope, el, attrs, ngModel) {
        if (!ngModel) return;
        //Default values
        scope.allowInvalid = angular.isDefined(attrs.allowInvalid)
          ? $parse(attrs.allowInvalid)(scope)
          : false;
        scope.selectOnBlur = angular.isDefined(attrs.selectOnBlur)
          ? $parse(attrs.selectOnBlur)(scope)
          : true;
        scope.selectOnExact = angular.isDefined(attrs.selectOnExact)
          ? $parse(attrs.selectOnExact)(scope)
          : true;
        scope.limit = attrs.limit || 10;

        scope.view2model = function(value) {
          ngModel.$setViewValue(value);
        };

        function findSelected(value) {
          return value == null || !scope.options.length
            ? null
            : scope.options.find(function(el) {
                //Search on label if scope.value is string
                if (
                  typeof el.value !== 'string' &&
                  typeof value === 'string' &&
                  typeof el.label === 'string'
                )
                  return el.label === value;

                //Match by id
                if (
                  typeof el.value === 'object' &&
                  typeof value === 'object' &&
                  typeof el.value.id === 'string' &&
                  typeof value.id === 'string'
                )
                  return angular.equals(el.value.id, value.id);
                return angular.equals(el.value, value);
              });
        }

        // when angular detects a change to the model,
        // we update our inner value
        ngModel.$render = function() {
          scope.value = ngModel.$viewValue;
          var selectedItem = findSelected(scope.value);
          if (selectedItem) {
            scope.selected = selectedItem;
          } else if (scope.allowInvalidInitialItem) {
            scope.value = getLabel(scope.value);
            scope.selected = scope.value;
          } else {
            scope.selected = scope.value;
          }
        };

        var getLabel = function(item) {
          if (!item) return null;
          if (scope.labelFunc)
            return scope.labelFunc({
              item: item,
            });
          if (!scope.label) return item;
          return item[scope.label];
        };

        scope.onSelect = function(i) {
          scope.selected = i;
          scope.value = i != null ? i.value : null;
          scope.view2model(scope.value);
        };
        scope.clearSelected = function() {
          scope.onSelect(null);
        };

        function mapOptions() {
          scope.options =
            !scope.orgOptions || !angular.isArray(scope.orgOptions)
              ? []
              : scope.orgOptions.map(function(val) {
                  return {
                    value: val,
                    label: getLabel(val),
                  };
                });
          if (!scope.noSort) scope.options.sort(dynamicSort('label'));
          scope.selected = findSelected(scope.value) || scope.value;
        }
        mapOptions();
        scope.$watchCollection('orgOptions', function(newValue, oldValue) {
          mapOptions();
          if (scope.autoSelect == 'true' && scope.options.length === 1 && !scope.selected)
            scope.onSelect(scope.options[0]);
        });

        scope.onChange = function() {
          if (scope.allowInvalid && typeof scope.selected === 'string') {
            scope.value = scope.selected;
            scope.view2model(scope.selected);
          }
        };
        //Clear textbox if value is not in option list
        scope.onBlur = function() {
          if (scope.selected == null) return;
          if (scope.allowInvalid && typeof scope.selected === 'string') {
            scope.value = scope.selected;
            scope.view2model(scope.selected);
          }
          if (!scope.allowInvalid && scope.options.indexOf(scope.selected) < 0)
            scope.onSelect(null);
        };
      },
    };
  },
]);
